import { View, Text } from 'react-native'
import React from 'react'

const ModalDragBar = () => {
  return (
        <View style={{ backgroundColor: '#ccc', width: 40, height: 3, alignSelf: 'center', borderRadius: 2, margin: 15}}></View>
  )
}

export default ModalDragBar